import { MAILBOX_INVALID_MESSAGE } from 'schemas/firm'
import { imageCaption } from './editors/imageCaptions'

export const messages = {
    UNEXPECTED_ERROR: 'ארעה שגיאה בלתי צפויה',
    DOCUMENT_DOES_NOT_EXIST: `המסמך לא נמצא`,
    DOCUMENT_TYPE_MISMATCH: `סוג המסמך לא תואם את הסוג הצפוי`,
    DOCUMENT_KIND_MISMATCH: `טיפוס המסמך לא תואם את הטיפוס הצפוי`,
    INVALID_BANK_ACCOUNT: `פרטי החשבון שגויים`,
    MISSING_IMAGES: `חסרות תמונות`,
    MISSING_BANK: `יש להזין מס׳ בנק`,
    MISSING_BRANCH: `יש להזין מס׳ סניף`,
    MISSING_ACCOUNT: `יש להזין מס׳ חשבון`,
    INVALID_BANK: `מס׳ הבנק לא תקין`,
    INVALID_CHECKSUM: `ספרת הביקורת שגויה`,
    INVALID_ACCOUNT_TOO_SHORT: `מס׳ החשבון קצר מדי`,
    INVALID_ACCOUNT_TOO_LONG: `מס׳ החשבון ארוך מדי`,
    BANK_IS_NOT_A_NUMBER: `מס׳ החשבון אינו מספר`,
    UNKNOWN_BANK: `מספר הבנק לא מוכר`,
    INVALID_VOUCHER: `השובר לא תקין`,
    VOUCHER_BENEFICIARY_UNKNOWN: `המוטב אינו מזוהה`,
    SAVE_FAILED: `השמירה נכשלה`,
    CONTACT_ADDRESSES_LOAD_FAILED: 'לא ניתן היה לטעון את הכתובות, ולכן אי אפשר לערוך אותן כרגע.',
    CONTACT_DETAILS_LOAD_FAILED: 'לא ניתן היה לטעון את פרטי הקשר, ולכן אי אפשר לערוך אותם כרגע.',
    CONTACT_ADDRESS_TYPE_INVALID: 'סוג הכתובת אינו תקין',
    CONTACT_DETAIL_TYPE_INVALID: 'סוג פרט הקשר אינו תקין',
    CONTACT_DETAIL_FLAG_INVALID: 'אחד הסימונים של פרט הקשר אינו תקין',
    CONTACT_ITEM_NOT_OWNED: 'אחד הפרטים לא נמצא. נא לרענן את הדף ולנסות שוב.',
    CONTACT_POSITIONS_INVALID: 'סדר הפרטים לא נשמר כי הרשימה השתנתה. נא לרענן את הדף ולנסות שוב.',
    CONTACT_DETAIL_LOCKED: 'לא ניתן לשנות פרט שאושר לדיוור או שהנמען ביקש להסיר.',
    CONSENT_STATEMENT_REQUIRED: 'יש לאשר את ההצהרה לפני סימון הפרט לדיוור.',
    CONSENT_STATEMENT_DECLINED: 'ההצהרה לא אושרה, ולכן הפרט לא סומן לדיוור.',
    CONSENT_UNSUBSCRIBED: 'הנמען ביקש להסיר את כתובתו מרשימת התפוצה, ולכן לא ניתן לסמן את הפרט הזה לדיוור.',
    CONSENT_UNAVAILABLE: 'לא ניתן לעדכן את סימון הדיוור כרגע. נסו שוב מאוחר יותר.',
    FIRM_NAME_REQUIRED: 'יש להזין את שם המשרד.',
    FIRM_MAILBOX_REQUIRED: 'יש להזין תיבת דואר למשרד.',
    FIRM_MAILBOX_INVALID: MAILBOX_INVALID_MESSAGE,
    FIRM_MAILBOX_TAKEN: 'תיבת הדואר כבר בשימוש של משרד אחר. נא לבחור תיבת דואר אחרת.',
    FIRM_MAILBOX_IMMUTABLE: 'אי אפשר לשנות את תיבת הדואר של משרד קיים.',
    TOO_MANY_IMAGES: 'הועלו יותר מדי תמונות, נא לפנות לתמיכה',
    CANNOT_CHANGE_DOCUMENT_TYPE: `אי אפשר לשנות את סוג המסמך`,
    SCHEDULED_CHECK_WITHOUT_PAYEE: `יש לבחור חשבון להפקדה לשיק מתוזמן`,
    SCHEDULED_CHECK_WITHOUT_DATE: `יש לבחור תאריך להפקדה לשיק מתוזמן`,
    UNSPECIFIED_DOC_TYPE: `נא לסרוק או להזין את המסמך`,
    ENTRY_SUM_MISMATCH: `הסכום הכולל של אמצעי התשלום אינו תואם לסכום הכולל של השוברים`,
    IMAGE_TYPE_NOT_ALLOWED: `סוג התמונה לא נתמך`,
    IMAGE_SIZE_EXCEEDED: 'גודל הקובץ גדול מדי',
    IMAGE_DPI_UNKNOWN: 'הרזולוציה של התמונה לא ידועה',
    IMAGE_DPI_INVALID: 'הרזולוציה של התמונה לא תואמת לסוג התמונה',
    ENTRY_DOCUMENT_REJECTED: `הרשומה נדחתה`,
    ENTRY_DOCUMENT_REJECTED_REASON_BANK: `מס׳ הבנק תרם לפסילת הרשומה`,
    ENTRY_DOCUMENT_REJECTED_REASON_BRANCH: `מס׳ הסניף תרם לפסילת הרשומה`,
    ENTRY_DOCUMENT_REJECTED_REASON_ACCOUNT: `מס׳ החשבון תרם לפסילת הרשומה`,
    ENTRY_DOCUMENT_REJECTED_REASON_SERIAL: `מס׳ השיק תרם לפסילת הרשומה`,
    ENTRY_DOCUMENT_REJECTED_REASON_AMOUNT: `סכום השיק תרם לפסילת הרשומה`,
    ENTRY_DOCUMENT_REJECTED_REASON_IMAGE: `התמונות תרמו לפסילת הרשומה`,
    IMAGE_FILE_MISSING: (params) => `קובץ התמונה חסר: ${imageCaption(params?.imageType)}. נא לסרוק את ה${params?.kind === 'voucher' ? 'שובר' : 'שיק'} מחדש.`,
    DUPLICATE_IMAGE_CHECK: (params) => `תמונה כפולה בשיק: ${imageCaption(params?.imageType)}. נא לסרוק את השיק מחדש.`,
    DUPLICATE_IMAGE_VOUCHER: (params) => `תמונה כפולה בשובר: ${imageCaption(params?.imageType)}. נא לסרוק את השובר מחדש.`,
    DUPLICATE_IMAGE_ACCEPTED_CHECK: (params) => `תמונה כפולה בשיק אושרה: ${imageCaption(params?.imageType)}.`,
    DUPLICATE_IMAGE_ACCEPTED_VOUCHER: (params) => `תמונה כפולה בשובר אושרה: ${imageCaption(params?.imageType)}.`,
}

export function messageOf(error) {
    const code = error?.response?.data?.error?.message
    return messages[code] ?? error?.message ?? messages.UNEXPECTED_ERROR
}

export default function Message({ code, params }) {
    if (code == null) {
        return null
    }

    if (!messages.hasOwnProperty(code)) {
        return code
    }

    const message = messages[code]
    return typeof message === 'function' ? message(params) : message
}
